import { useEffect, useState } from "react";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Box, Button } from "@mui/material";
import "./styles.css";
import CustomActionButton from "../CustomActionButton/CustomActionButton";
import SaveResultDialogBox from "../SaveResultDialogBox/SaveResultDialogBox";
import DeleteAudioDialog from "../DeleteAudioDialog/DeleteAudioDialog";
import uploadAudio from "../../fetchApi/uploadAudio";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";
import { UrlConstants } from "../../utils/CommonUtils/constants.js";
import CustomBackdrop from "../CustomBackdrop/CustomBackdrop";
import { formatTime } from "../../utils/formatTime.js";

const CustomAudioRecorder = ({
  isRecording,
  isStopped,
  isPaused,
  audioBlob,
  setAudioBlob,
  startRecording,
  stopRecording,
  resumeRecording,
  hideSlider,
  setHideSlider,
  audioBlobForAudioPlayer,
  processedData,
  setProcessedData,
  assessmentId,
  setAssessmentId,
  studentName,
  setStudentName,
  orfResultStatus,
  setOrfResultStatus,
  selectedLaguage,
  setSelectedLaguage,
  saveClicked,
  setSaveClicked,
  isAudioUploading,
  setAudioUploading,
  uploadAudioStatus,
  setUploadAudioStatus,
  setAssessmentSaveAudioConfirmationDrawer,
  showSaveResultDialog,
  setShowSaveResultDialog,
  setActiveScreen,
}) => {
  const [showDeleteAudioDialog, setShowDeleteAudioDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const { t } = useTranslationSetup();
  const [time, setTime] = useState(0);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  let currInterval;

  const handleStartRecording = () => {
    setOpenBackdrop(true);
    setTimeout(() => {
      if (!openBackdrop) {
        setHideSlider(true);
        startRecording();
      }
    }, 5500);
  };

  const handleStopRecording = () => {
    stopRecording();
  };

  useEffect(() => {
    if (isRecording) {
      currInterval = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
    return () => {
      clearInterval(currInterval);
      setTime(0);
    };
  }, [isRecording]);

  useEffect(() => {
    if (saveClicked === true) {
      // setTimeout(() => {
      uploadAudio(
        UrlConstants.BASE_URL +
          UrlConstants.BASE_PATH_URL +
          UrlConstants.ASSESSMENT +
          `/${assessmentId}/upload?self_audio_validation=${1}`,
        audioBlobForAudioPlayer
      )
        .then((result) => {
          if (result["status"] !== null || result["status"] !== undefined) {
            setAudioUploading(false);
            setUploadAudioStatus(result["status"]);
          }
        })
        .catch(() => {
          setUploadAudioStatus("ERR_INTERNET_DISCONNECTED");
        });
      // }, 3000);
    }
  }, [saveClicked]);

  return (
    <>
      <Box>
        <CustomBackdrop
          openBackdrop={openBackdrop}
          setOpenBackdrop={setOpenBackdrop}
          t={t}
        />
      </Box>
      <Box>
        <SaveResultDialogBox
          isDialogOpen={showSaveResultDialog}
          setDialogOpen={setShowSaveResultDialog}
          processedData={processedData}
          setProcessedData={setProcessedData}
          assessmentId={assessmentId}
          setAssessmentId={setAssessmentId}
          audioBlob={audioBlob}
          setAudioBlob={setAudioBlob}
          hideSlider={hideSlider}
          setHideSlider={setHideSlider}
          uploadAudioStatus={uploadAudioStatus}
          setUploadAudioStatus={setUploadAudioStatus}
          studentName={studentName}
          setStudentName={setStudentName}
          isAudioUploading={isAudioUploading}
          setAudioUploading={setAudioUploading}
          showErrorDialog={showErrorDialog}
          setShowErrorDialog={setShowErrorDialog}
          orfResultStatus={orfResultStatus}
          setOrfResultStatus={setOrfResultStatus}
          selectedLaguage={selectedLaguage}
          setSelectedLaguage={setSelectedLaguage}
          saveClicked={saveClicked}
          setSaveClicked={setSaveClicked}
          setActiveScreen={setActiveScreen}
        />
        <DeleteAudioDialog
          isDialogOpen={showDeleteAudioDialog}
          setDialogOpen={setShowDeleteAudioDialog}
          hideSlider={hideSlider}
          setHideSlider={setHideSlider}
          audioBlob={audioBlob}
          setAudioBlob={setAudioBlob}
        />
      </Box>
      <Box className="custom-button-container">
        {isStopped && audioBlob != null && (
          // hideSlider == true
          <Box
            className="delete-audio-dialog-box"
            onClick={() => setShowDeleteAudioDialog(true)}
          >
            <CustomActionButton text={t("retake")}>
              <CloseOutlinedIcon />
            </CustomActionButton>
          </Box>
        )}
        <Box>
          <Box>
            {isRecording && (
              <Box className="recording-container">
                <Box className="flash-recording-dot" />
                <Box className="format-time-box">{formatTime(time)}</Box>
              </Box>
            )}
            <Box className="start-button-box">
              <Button
                className="start-button"
                variant={
                  isRecording
                    ? "outlined"
                    : audioBlob !== null && isStopped
                      ? "outlined"
                      : "contained"
                }
                style={{
                  color: isRecording
                    ? "#E47714"
                    : audioBlob !== null && isStopped
                      ? "#AEAEAE"
                      : "#fff",
                  background: isRecording
                    ? "#fff"
                    : audioBlob !== null && isStopped
                      ? ""
                      : "#E47714",
                  border:
                    audioBlob !== null && isStopped
                      ? "1px solid #AEAEAE"
                      : "1px solid #E47714",
                }}
                disabled={audioBlob !== null && isStopped ? true : false}
                disableElevation
                onClick={() => {
                  if (isRecording) {
                    handleStopRecording();
                  } else if (isPaused) {
                    resumeRecording();
                  } else {
                    handleStartRecording();
                  }
                }}
              >
                {isStopped && audioBlob === null ? (
                  <>{t("start")}</>
                ) : isRecording ? (
                  <>{t("stop")}</>
                ) : (
                  <>{t("stop")}</>
                )}
              </Button>
            </Box>
          </Box>
        </Box>
        {isStopped && audioBlob != null && (
          // hideSlider == true
          <Box
            className="save-audio-drawer"
            onClick={() => {
              // setAudioUploading(true);
              // setShowSaveResultDialog(true);
              // setSaveClicked(true);
              setAssessmentSaveAudioConfirmationDrawer(true);
            }}
          >
            <CustomActionButton text={t("save")}>
              <DoneOutlinedIcon />
            </CustomActionButton>
          </Box>
        )}
      </Box>
    </>
  );
};

export default CustomAudioRecorder;
